// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"605":"67f0546a14c03f91","7003":"6398540dd695ef89"}[chunkId] + ".css";
};